import React from 'react';
import { Card, LinearProgress, Avatar } from 'material-ui';

const LoadingBox = () => {
  return (
    <div style={{ padding: '0 1px' }}>
      <div style={{ display: 'inline-block', verticalAlign: 'top', padding: '0 10px', width: '11%' }}>
        <Avatar
          backgroundColor="#E0E0E0"
          style={{
            border: '0px solid #E0E0E0',
            height: '40px',
            marginTop: '10px',
            position: 'relative',
            width: '40px',
          }}
        />
      </div>
      <Card style={{ display: 'inline-block', width: '89%', padding: '2%', margin: '10px 0', color: 'rgba(0, 0, 0, 0.54)' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ width: '80%', display: 'flex', flexDirection: 'column' }}>
            <div style={{ flexGrow: 1, width: '40%', height: '24px' }}><LinearProgress style={{ height: '8px' }} color="#aeaeae"/></div>
            <LinearProgress style={{ flexGrow: 1, height: '8px' }} color="#aeaeae" mode="determinate" max={100} min={0} value={80}/>
          </div>
        </div>
        <div style={{ margin: '24px 0', display: 'flex', flexDirection: 'column' }}>
          <div style={{ flexGrow: 1, height: '24px' }}><LinearProgress style={{ height: '8px' }} color="#aeaeae" mode="determinate" max={100} min={0} value={70}/></div>
          <div style={{ flexGrow: 1, height: '24px' }}><LinearProgress style={{ height: '8px' }} color="#aeaeae" mode="determinate" max={100} min={0} value={40}/></div>
          <LinearProgress style={{ flexGrow: 1, height: '8px', width: '80%' }} color="#aeaeae"/>
        </div>
      </Card>
    </div>
  );
};

export default LoadingBox;



// WEBPACK FOOTER //
// ./src/app/components/newsfeed/mainFeed/postTypes/loadingBox.jsx